import React from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Text, Spinner} from '@chakra-ui/react';

const LoadingSpinner = () => {
  const {t} = useTranslation();

  return (
      <Box textAlign="center">
        <Spinner size="xl"/>
        <Text mt={2}>{t('loading')}...</Text>
      </Box>
  );
}

export default LoadingSpinner;